<div class="cancel-option">
    <div class="credit-heading">
        <h4>Cancel</h4>
        <div class="close-icon">
            <img src="../../../../assets/images/export-close.svg" alt="Close" (click)="closeDialog()" />
        </div>
    </div>
     <div *ngIf="bookingScheduledDate" class="schedule-message">{{bookingScheduledDate}}</div>
    <div *ngIf="showError" class="pass-err">{{validationErrorMessage}}</div>
    <form [formGroup]="cancelOptionForm" (ngSubmit)="onSubmit()">
        <div class="cancel-listing">
            <div #focusTrap tabindex="0"></div>
            <h5>Please select how you want to cancel this booking:</h5>
            <div class="radio-btn-outer">

                <div *ngIf="!showRadioButtonsForPendingCase && !onlyShowSubscriptionCancelOption"
                    class="single-radio-btn" (click)="setCancelOption(cancelType.IsBookingRefund)">
                    <p-radioButton class="payment-method" name="cancelOption" formControlName="cancelOption" id="refund"
                        [value]="cancelType.IsBookingRefund" inputId="refund" variant="filled"
                        (onClick)="setCancelOption(cancelType.IsBookingRefund)">
                    </p-radioButton>
                    <label for="refund" [innerHTML]="cancelBookingTitle.withRefund.title"></label>
                </div>

<div *ngIf="!onlyShowSubscriptionCancelOption" class="single-radio-btn"
                    (click)="setCancelOption(cancelType.IsBookingWithoutRefund)">
                    <p-radioButton class="payment-method" name="cancelOption" formControlName="cancelOption"
                       id="no-refund" [value]="cancelType.IsBookingWithoutRefund" inputId="no-refund" variant="filled"
                        (onClick)="setCancelOption(cancelType.IsBookingWithoutRefund)">
                    </p-radioButton>
                    <label for="no-refund"
                        [innerHTML]="showRadioButtonsForPendingCase ? 'Cancel current booking': cancelBookingTitle.withoutRefund.title"></label>
                </div>

<div *ngIf="(bookingType === bookingTypeDetails.Recurring) || onlyShowSubscriptionCancelOption"
                    class="single-radio-btn" (click)="setCancelOption(cancelType.IsBookingOnlySubscriptionCancel)">
                    <p-radioButton class="payment-method" name="cancelOption" formControlName="cancelOption"
                       id="subscription-only" [value]="cancelType.IsBookingOnlySubscriptionCancel" inputId="subscription-only"
                        variant="filled" (onClick)="setCancelOption(cancelType.IsBookingOnlySubscriptionCancel)">
                    </p-radioButton>
                    <label for="subscription-only">{{
                        cancelBookingTitle.subscriptionOnly.title
                        }}</label>
                </div>

<div class="single-dropdown date-outer" *ngIf="bookingType != 0">
                    <label for="cancellationReason">Reason<span class="custom-star">*</span></label>
                    <div class="custom-select2 custom-date-calender" appendTo="body">
                        <p-dropdown [appendTo]="'body'" id="cancellationReason" formControlName="cancellationReason"
                            [options]="cancellationReasons" [placeholder]="'Select a reason'"
                            (onChange)="cancellationReasonsOnChanges($event)"></p-dropdown>
                        <img src="assets/images/fill-dropdown.svg" alt="" />
                    </div>
                </div>

<div class="single-textarea" *ngIf="bookingType != 0">
                    <textarea id="additional-comments" formControlName="additionalComments" maxlength="512" rows="4" placeholder="Additional Note"></textarea>
                </div>

<app-schedule-date-time-option *ngIf="isScheduleCancelOption && !(roleName === userRoles.DRIVER || roleName === userRoles.GROUP_USER)" [bookingEndDate]="bookingEndDate"
                    [bookingType]="bookingType" [isSubmitButtonClicked]="isSubmitButtonClicked" [bookingScheduledDate]="bookingScheduledDate"
                    [isScheduleCancelBookingMessage]="isScheduleCancelBookingMessage" [timeZone]="timeZone"
                    (schdeuleDateTimeData)="schdeuleDateTimeData($event)"></app-schedule-date-time-option>
            </div>
        </div>
        <div class="continue-btn">
            <p-button type="submit" label="Continue"></p-button>
        </div>
    </form>
</div>
